<script setup lang="ts">
import { ref, onMounted } from 'vue';
import MultistepForm from './components/MultistepForm.vue';
import type { Settings } from './types/general';
import { getSettings } from './api/index';

const settings = ref<Settings>();

onMounted(async () => {
  settings.value = await getSettings();
});
</script>

<template>
  <MultistepForm
    v-if="settings"
    :settings="settings"
  />
</template>
